import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useFirebase } from "./context";
import { useRouteContext } from "./route-context";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useFirebase();
  const location = useLocation();
  const routeContext = useRouteContext();
  const requestedPath = `${location.pathname}${location.search}${location.hash}`;
  const hasAnonymousGuestPass =
    location?.state?.anonymousGuest === true ||
    location?.state?.from === "anonymous" ||
    window.sessionStorage.getItem("blogAnonymousGuest") === "true";

  useEffect(() => {
    if (!user) {
      routeContext.setPath(requestedPath);
    }
  }, [user, requestedPath]);

  if (loading) return null;
  if (location?.state?.from === "ai-suggestor") return children;
  if (hasAnonymousGuestPass) return children;
  if (location?.pathname === "/blog/post/ramadan-is-difficult") return children;
  if (!user) return <Navigate to="/" replace />;

  return children;
};

export default ProtectedRoute;
